import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined"
import Button from "@mui/material/Button"
import Chip from "@mui/material/Chip"
import { styled } from "@mui/material/styles"

export default function ApplyFiltersButton({ openFiltersDialog, filters }) {
  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={<FiltersChip label={filters.length} />}
      endIcon={<FilterListOutlinedIcon />}
      onClick={openFiltersDialog}
    >
      Apply Filters
    </Button>
  )
}

const FiltersChip = styled((props) => (
  <Chip color="secondary" size="small" {...props} />
))(({ theme }) => ({
  borderRadius: "6px",
  background:
    "linear-gradient(159deg, rgba(255, 255, 255, 0.8) 3.01%, rgba(255, 255, 255, 0.65) 103.3%)",
  backdropFilter: "blur(21px)",
  height: "20px",
  "& .MuiChip-label": {
    fontSize: "14px",
    paddingInline: "6px",
    lineHeight: 1,
  },
}))
